import api from '.';
import logger from '../utils/logger';
import store from '../redux/store';
import { UpdateUserInvitationPayload, UserInvitation } from '../types/profile';
import {
  CreateAccountRequest,
  CreateAccountResponse,
  InviteTeamRequest,
  InviteTeamResponse,
  StartSignupRequest,
  StartSignupResponse,
  ValidateTokenResponse,
} from '../types/signup/common';

export enum SignupServiceErrorCode {
  COMPANY_ALREADY_EXISTS = 'SS_012',
}

export const startSignup = async (
  requestBody: StartSignupRequest,
): Promise<StartSignupResponse> => {
  try {
    const { data } = await api.post('/signup/', requestBody);
    return data;
  } catch (error) {
    logger('error', 'error at startSignup api call', error);
    throw error;
  }
};

export const validateSignupToken = async (token: string): Promise<ValidateTokenResponse> => {
  try {
    const { data } = await api.get(`/signup/validate-token?token=${token}`);
    return data;
  } catch (error) {
    logger('error', 'error at validateSignupToken api call', error);
    throw error;
  }
};

export const validateCompanySignup = async (token: string): Promise<ValidateTokenResponse> => {
  try {
    const { data } = await api.get(`/signup/validate-company-signup?token=${token}`);
    return data;
  } catch (error) {
    logger('error', 'error at validateCompanySignup api call', error);
    throw error;
  }
};

export const createAccount = async (
  requestBody: CreateAccountRequest,
): Promise<CreateAccountResponse> => {
  try {
    const { data } = await api.post('/signup/complete', requestBody);
    return data;
  } catch (error) {
    logger('error', 'error at createAccount api call', error);
    throw error;
  }
};

export const inviteTeam = async (
  companyId: number,
  requestBody: InviteTeamRequest,
): Promise<InviteTeamResponse> => {
  try {
    const { data } = await api.post(`/signup/companies/${companyId}/userInvitations`, requestBody);
    return data;
  } catch (error) {
    logger('error', 'error at inviteTeam api call', error);
    throw error;
  }
};

export const createAccountInCompany = async (
  requestBody: CreateAccountRequest,
): Promise<CreateAccountResponse> => {
  try {
    const { data } = await api.post('/signup/complete-invite', requestBody);
    return data;
  } catch (error) {
    logger('error', 'error at createAccountInCompany api call', error);
    throw error;
  }
};

export const getUserInvitations = async (): Promise<UserInvitation[]> => {
  try {
    const { data } = await api.get(
      `/signup/companies/${store.getState().auth.authContext?.companyId}/userInvitations`,
    );
    return data;
  } catch (error) {
    logger('error', 'error at getUserInvitations api call', error);
    throw error;
  }
};

export const updateUserInvitation = async (
  email: string,
  requestBody: UpdateUserInvitationPayload,
): Promise<void> => {
  try {
    const { data } = await api.patch(
      `/signup/companies/${store.getState().auth.authContext?.companyId}/userInvitations/${email}`,
      requestBody,
    );
    return data;
  } catch (error) {
    logger('error', 'error at updateUserInvitations api call', error);
    throw error;
  }
};

export const deleteUserInvitation = async (email: string): Promise<void> => {
  try {
    const { data } = await api.delete(
      `/signup/companies/${store.getState().auth.authContext?.companyId}/userInvitations/${email}`,
    );
    return data;
  } catch (error) {
    logger('error', 'error at deleteUserInvitations api call', error);
    throw error;
  }
};
